import { api } from '@/services/axios'

export interface UpdateProfileBody {
  id: number
  email: string
  nome: string
  whatsapp?: string
}

export async function updateProfile(data: UpdateProfileBody) {
  try {
    const response = await api.put(`/Usuario/Update/${data.id}`, data)
    return response.data
  } catch (error) {
    console.error('Erro ao atualizar o perfil:', error)
    throw error
  }
}
